import React from "react";
import { LoadingV2 } from "@ucl/library";
import "./RemainingFields.scss";

interface RemainingFieldsPopoverProps {
  /** List of remaining field names to display */
  fields?: string[];
  /** Whether the fields are currently loading */
  isLoading: boolean;
  /** The total count of fields/tasks */
  totalCount: number;
  /** Label to display in the popover header */
  popoverLabel?: string;
  /** Optional label to display before the count */
  label?: string;
}

/**
 * RemainingFieldsPopover component displays the content inside the popover
 * for the RemainingFields component.
 */
export const RemainingFieldsPopover: React.FC<RemainingFieldsPopoverProps> = ({
  fields,
  isLoading,
  totalCount,
  popoverLabel,
  label,
}) => {
  if (isLoading) {
    return (
      <div className="remaining-fields__popover">
        <div className="remaining-fields__popover-loading">
          <LoadingV2 height="20px" width="20px" />
        </div>
      </div>
    );
  }

  if (totalCount === 0) {
    return (
      <div className="remaining-fields__popover">
        <div className="remaining-fields__popover-empty">
          <span>No remaining items.</span>
        </div>
      </div>
    );
  }
  else if (!fields || fields.length === 0) {
    return (
      <div className="remaining-fields__popover">
        <div className="remaining-fields__popover-empty">
          <span>Error determining remaining items.</span>
        </div>
      </div>
    );
  }

  const displayLabel = popoverLabel || label || "Remaining Items";

  return (
    <div className="remaining-fields__popover">
      <div className="remaining-fields-popover__header">
        <h3 className="remaining-fields-popover__title">{displayLabel}</h3>
        <h3 className="remaining-fields-popover__title-count">{fields.length} {!!totalCount ? `/ ${totalCount}` : ""}</h3>
      </div>
      <div className="remaining-fields__popover-content">
        <div className="remaining-fields__popover-fields">
          {fields.map((field, index) => (
            <div key={index} className="remaining-fields__popover-field">
              {field}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RemainingFieldsPopover;
